import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Color from '../../utils/colors';
import { Font, FontWeight } from '../../utils/fonts';
import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import Links from '../../utils/links';
import Analytics from '../../services/Analytics';

import Content from '../../common/Content';

// import fb from './assets/fb.svg';
import logo from './assets/logo.svg';
import { directionsName } from '../../utils/directionsData';

class Footer extends Component {
    static handleClick() {
        Analytics.sendEvent('go to facebook from footer');
    }

    render() {
        const { className, handleChangePage } = this.props;

        return (
            <Root className={className}>
                <ContentStyled>
                    <LinkTo onClick={() => handleChangePage(Links.MAIN)}>
                        <Logo>
                            <Image src={logo} />
                        </Logo>
                    </LinkTo>
                    <ItemsBlock>
                        <LinkStyled onClick={() => handleChangePage(Links.RESEARCH)}>
                            {directionsName.RESEARCH}
                        </LinkStyled>
                        <LinkStyled onClick={() => handleChangePage(Links.DESIGN)}>
                            {directionsName.DESIGN}
                        </LinkStyled>
                        <LinkStyled onClick={() => handleChangePage(Links.LAUNCH)}>
                            {directionsName.LAUNCH}
                        </LinkStyled>
                        <LinkStyled onClick={() => handleChangePage(Links.TEAM)}>
                            Команда
                        </LinkStyled>
                        <LinkStyled onClick={() => handleChangePage(Links.CONTACTS)}>
                            Контакты
                        </LinkStyled>
                    </ItemsBlock>
                    <Icon>
                        {/* <A href="https://www.facebook.com/Aventicalab/" target="blank" onClick={Footer.handleClick}>    */}
                        {/*    <Image src={fb} />   */}
                        {/* </A>    */}
                    </Icon>
                    <LawyerInfo>
                        ООО «Авентика Лаб»
                        125167, г. Москва, улица Красноармейская, дом 11, корпус
                        10, помещение II комн.26 эт.1
                        ИНН 7726365678
                    </LawyerInfo>
                </ContentStyled>
            </Root>
        );
    }
}

const Root = styled.div`
    ${Font.PRIMARY};
    ${FontWeight.REGULAR};

    background: #000000;
`;

const Logo = styled.div`
    display: none;

    ${mediaWidth.l} {
        display: block;

        margin-right: 68px;
    }

    ${mediaWidth.xl} {
        margin-right: 0px;
    }
`;

const ContentStyled = styled(Content)`
    position: relative;

    padding-top: 32px;
    padding-bottom: 56px;

    ${mediaWidth.m} {
        display: flex;
        align-items: center;

        padding-top: 62px;
        padding-bottom: 93px;
    }

    ${mediaWidth.xl} {
        justify-content: space-between;
        padding-top: 81px;
        padding-bottom: 75px;
    }
`;

const ItemsBlock = styled.div`
    display: flex;
    flex-direction: column;

    ${mediaWidth.m} {
        flex-direction: row;
        align-items: center;
    }
`;

const LinkTo = styled.div`
    cursor: pointer;
`;

const LinkStyled = styled(LinkTo)`
    color: ${Color.TEXT_SECONDARY};
    font-size: 16px;
    line-height: 24px;

    margin-bottom: 16px;
    &:last-child {
        margin-bottom: 0px;
    }

    ${mediaWidth.m} {
        font-size: 18px;
        line-height: 23px;

        margin-bottom: 0px;
        margin-right: 24px;

        :active {
            color: #FFFFFF;
            opacity: 0.64;
        }
    }

    ${mediaWidth.l} {
        :hover {
            color: #FFFFFF;
            opacity: 0.56;
        }
    }

    ${mediaWidth.xl} {
        margin-right: 32px;
    }
`;

const Icon = styled.div`
    position: absolute;
    /* bottom: 32px; */
    bottom: 50px;
    right: 0px;

    ${mediaWidth.m} {
        position: static;
        margin-left: 16px;
        bottom: 32px;
    }

    ${mediaWidth.l} {
        margin-left: 43px;
    }

    ${mediaWidth.xl} {
        margin-left: 0px;
    }
`;

const Image = styled.img`
    display: block;

    :hover {
        opacity: 0.64;
    }
`;

// const A = styled.a`
//     text-decoration: none;
// `;

const LawyerInfo = styled.div`
    width: 100%;
    position: absolute;
    top: 125px;
    left: 50%;
    transform: translateX(-50%);
    
    font-size: 10px;
    line-height: 12px;
    color: ${Color.TEXT_SECONDARY};
    text-align: center;
    
    display: none;

    ${mediaWidth.m} {
        width: 100%;
        position: absolute;
        top: 115px;
        left: 50%;
        transform: translateX(-50%);

        font-size: 8px;
        line-height: 10px;
        
        display: block;
    }

    ${mediaWidth.l} {
        top: 125px;

        font-size: 10px;
        line-height: 12px;
    }
`;

export default Footer;
